import React from 'react'

import LoginHeader from "../Login/LoginHeader";
import Footer from "../Common/footer";
import { CircularProgress } from "@mui/material";
export default function AccessDenied() {

  return (
    <div>
      <LoginHeader />
      <div className="container">
        <div className="access-page">
          <div className="access-page-inner">
          <img src="../assets/images/access-denied.svg" className="img-fluid" alt="Access Denied"/>
          <h2 className="h2">Access Denied</h2>
          <h4 className="h4">Sorry, you are not authorized to view this page</h4>
          </div>
          </div>
      </div>
      <Footer/>
    </div>
  );
}
